import { useContext } from "react";
import { VideosContext } from "../components/context/videos-context";
export var useVideos = function useVideos() {
  return useContext(VideosContext) || [];
};